import { supabase } from '../lib/supabase';

export const plansService = {
  // Get all active plans for pricing page
  async getActivePlans() {
    try {
      const { data, error } = await supabase?.from('plans')?.select('*')?.eq('is_active', true)?.order('price_cents', { ascending: true });

      if (error) {
        throw error;
      }

      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Get plan by code
  async getPlanByCode(planCode) {
    try {
      const { data, error } = await supabase?.from('plans')?.select('*')?.eq('code', planCode)?.eq('is_active', true)?.single();

      if (error) {
        throw error;
      }

      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Handle successful signup with plan assignment
  async handleSuccessfulSignup(orgId, planCode) {
    try {
      const { error } = await supabase?.rpc('handle_successful_signup', {
        org_id_param: orgId,
        plan_code_param: planCode
      });

      if (error) {
        throw error;
      }

      return { error: null };
    } catch (error) {
      return { error };
    }
  },

  // Update organization billing info
  async updateOrgBilling(orgId, billingData) {
    try {
      const { data, error } = await supabase?.from('orgs')?.update({
          billing_status: billingData?.billing_status,
          stripe_customer_id: billingData?.stripe_customer_id,
          stripe_subscription_id: billingData?.stripe_subscription_id,
          updated_at: new Date()?.toISOString()
        })?.eq('id', orgId)?.select()?.single();

      if (error) {
        throw error;
      }

      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Get organization with plan info
  async getOrgWithPlan(orgId) {
    try {
      const { data, error } = await supabase?.from('orgs')?.select(`
          *,
          plan:plans(*)
        `)?.eq('id', orgId)?.single();

      if (error) {
        throw error;
      }

      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  }
};